import './base/';
import './sliders/product-slider';
import './variant';
import 'magnific-popup';

const $win = $(window);
const $doc = $(document);
const $body = $('body');
const mobileWidth = 768;

// Show Sub Menu on mobile devices
function mobileNav() {
  $('.nav a').on('click', function(e){
    var $this = $(this);
    var $parent = $this.parent();
    var $hasSubMenu = $this.next('ul');

    if( $hasSubMenu.length ) {
      if(!$parent.hasClass('opened')) {
        e.preventDefault();

        $parent.addClass('opened').siblings().removeClass('opened');
      }
    }
  });
};

/**
 * Adding active class on Body on nav-trigger click
 */

$('.nav-trigger').on('click',function(){
	event.preventDefault();

	$('body').toggleClass('active');

  mobileNav();
});

// Handle the show/hide logic
$('.nav .js-accordion .js-accordion-head').on('click', function (event) {
  if ($win.width() < mobileWidth) {

    $('.nav .js-accordion').toggleClass('js-accordion--active');
    $('.nav .js-accordion .js-accordion-body').stop().slideToggle();
  }
});

$('.filter .filter-trigger').on('click', function (event) {
  event.preventDefault();

  $(this).toggleClass('filter-trigger--active');

  $('.filter .js-accordion-body').slideToggle();
});

/**
 * On click outside the nav removing accordion active class
 * and sliding up the accordion body
 */

$doc.on('click touchstart', function(event){
  var $target = $(event.target);

  if(!$target.parents('.nav').length ){
    $('.nav .js-accordion').removeClass('js-accordion--active');
    $('.nav li').removeClass('opened');
    $('.nav .js-accordion .js-accordion-body').slideUp();
  }
});

/**
 * Hides an element and removes active classes from a trigger element and the `html` tag
 *
 * @param  {Object} event                    Event data
 *
 * @return {Void}
 */
const activeClass = 'active';
const currentClass = 'current';

function hideElementOnDocumentClick(event, clickHandler) {
  var $target = $(event.target);
  var $wrapper = $('.wrapper');
  var $body = $('body');

  var elementClass = clickHandler.elementClass;
  var triggerClass = clickHandler.triggerClass;
  var elementVisibleClass = clickHandler.elementVisibleClass;
  var triggerActiveClass = clickHandler.triggerActiveClass;
  var globalVisibleClass = clickHandler.globalVisibleClass;

  if (
      !$target.hasClass(elementClass) &&
      !$target.parents('.' + elementClass).length &&
      !$target.hasClass(triggerClass) &&
      !$target.parents('.' + triggerClass).length
  ) {
      $('.' + elementClass).removeClass(elementVisibleClass);
      $('.' + triggerClass).removeClass(triggerActiveClass);

      $wrapper.removeClass(globalVisibleClass);
      $body.removeClass(globalVisibleClass);
  }
}

/**
 * @param  {String} elementClass             Selector for the element to hide
 * @param  {String} triggerClass             Selector for the trigger
 * @param  {String} elementVisibleClass      Classname to remove from the element
 * @param  {String} triggerActiveClass       Classname to remove from the trigger
 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
 */
var clickHandlers = [
  {
    elementClass: 'nav',
    triggerClass: 'nav-trigger',
    elementVisibleClass: 'nav--active',
    triggerActiveClass: 'nav-trigger--active',
    globalVisibleClass: activeClass
  }
];

$doc.on('click touchend', function(event) {
  clickHandlers.forEach(function(clickHandler) {
    hideElementOnDocumentClick(event, clickHandler);
  });
});





filterTags();

function filterTags() {
  var filerSize;

  $('.filter li a').each(function() {
    var $this = $(this);
    var string = document.location.href;
    var substring = $this.data('text');

    if (string.indexOf(substring) !== -1) {
      $this.closest('li').addClass('current');
    }
  });

  $('.filter li a').on('click', function(event) {
    event.preventDefault();

    $(this)
      .closest('li')
      .toggleClass('current')
      .siblings()
      .removeClass('current');


    var href            = $('.section--shopping-page').data('collection');
    var newHref;

    if ($('.filter-size li.current').length) {
      filerSize = $('.filter-size li.current a').data('size');
    } else {
      filerSize = '';
    }

    newHref = href + '/' + filerSize;

    location.replace(newHref);
  });
}

// Popovers

popovers($('.js-popover'), $('.js-close-popover'), 'open');

function popovers($btnOpen, $btnClose, activeClass) {
  var $target;

  $btnOpen.on('click', function(event) {
    event.preventDefault();

    const $this   = $(this);
    $target       = $($this.data('target'));

    const $searchInput = $target.find('.search__field');

    setTimeout(function() {
      $searchInput.focus();
    }, 310);

    $target.addClass(activeClass);
  });

  $btnClose.on('click', function(event) {
    event.preventDefault();

    $target.removeClass(activeClass)
  });
}


clearForm($('.btn-reset'));

function clearForm($clearbtn) {
  $clearbtn.on('click', function(event) {
    event.preventDefault();

    $(this).closest('.subscribe').find('input[type="email"]').val('')
  });
}
